import { AxiosPromise } from "axios";
import { dashboardApiConfig, ops } from "./config";
import {
  AssignPosLocation,
  LocationDto,
  LocationsResourceApi,
  TransferFilesDto,
} from "../generated/dashboard-client";

const api = new LocationsResourceApi(dashboardApiConfig);

const AccountLocationApi = {
  getLocation(id: string, internalId: number = 0): AxiosPromise<LocationDto> {
    return api.getLocation(id, internalId, ops());
  },
  updateLocation(dto: LocationDto): AxiosPromise<void> {
    return api.updateLocation(dto, ops());
  },
  deleteLocation(id: number): AxiosPromise<void> {
    return api.deleteLocation(id, ops());
  },
  transferTimberDesign(dto: TransferFilesDto): AxiosPromise<void> {
    return api.transferDigitalProducts(dto, ops());
  },
  assignPopmenuLocation(dto: AssignPosLocation): AxiosPromise<void> {
    return api.assignPopmenuLocation(dto, ops());
  },
  getLocationUserCount(locationId: number): AxiosPromise<number> {
    return api.getLocationUserCount(locationId, ops());
  },
};

export default AccountLocationApi;
